import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import { SmallLoader } from '../../../components/SmallLoader';
import { uploadingToastSelector } from '../../../store/ui';

const Msg = () => (
  <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
    <SmallLoader />
    <span>Your videos are processing...</span>
  </div>
);

const WithUploadingToastContainer = ({ children }) => {
  const uploadingToast = useSelector(uploadingToastSelector);
  useEffect(() => {
    if (uploadingToast.isOpen) {
      toast.info(<Msg />);
    }
  }, [uploadingToast.isOpen]);
  return (
    <>
      {children}
      {uploadingToast.isOpen && (
        <ToastContainer
          position="top-center"
          autoClose={false}
          closeButton={false}
          draggable={false}
          closeOnClick={false}
          limit={1}
          containerId="with-uploading"
        />
      )}
    </>
  );
};

export default WithUploadingToastContainer;
